export const COPYRIGHT_TEXT = 'Envita Solutions, LLC Release - IS2'
export const DEFAULT_MANDATORY_ERROR = 'Please fill in mandatory fields:'
